import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class about extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {



        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }

        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>







                ​

                ​

                    </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >

                    {lang==="en" &&<div style={{width: "25%", maxWidth:"25%",  minWidth:"20em", padding:0, verticalAlign:"top", display: "inline-block", top:"0px",backgroundColor:"FireBrick" }} >

                    <div style={{ display: "inline-block", textAlign: "center", color:"white", padding:0, height: "50%", minWidth:"20em", maxHeight: "20em", width: "100%"}} ><img alt="Xinlin"  style={{top:"0px", minWidth:"20em", maxWidth:"100%", }} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/xinlin.jpg?alt=media&token=c625f3e2-e8aa-4407-ace5-dba2feed3c0e"/>
                       <br/> <span  style={{width:"100%", }} >XINLIN LI MORROW</span><br/>
                        <span  style={{textAlign: "center"}}>PRINCIPAL</span><br/><br/>
                    </div>
                    <div style={{  padding:10, display: "inline-block", backgroundColor:"FireBrick", height: "50%", width: "100%", color:"white"}} >
                        <span style={{ fontWeight: "bold"}}>XINLIN@MORROWFIRM.COM</span><br/>
                        <span style={{ fontWeight: "bold"}}>213.282.8166</span><br/><br/>
                        <span style={{ fontWeight: "bold"}}>EDUCATION</span><br/>
                        <span>Columbia Law School (J.D., 2010)</span> <span style={{ fontStyle: "italic"}}>Harlan Fiske Stone Scholar</span><br/>
                        <span>Middlebury College (B.A., Economics, 2007) <span style={{ fontStyle: "italic"}}>cum laude</span></span><br/><br/>
                        <span style={{ fontWeight: "bold"}}> ADMISSIONS</span><br/>
                        <span>California</span><br/>
                        <span>New York </span><br/>
                    </div>
                </div>}

                    {lang==="zh" &&<div style={{width: "25%", maxWidth:"25%",  minWidth:"20em", padding:0, verticalAlign:"top", display: "inline-block", top:"0px",backgroundColor:"FireBrick" }} >

                        <div style={{ display: "inline-block", textAlign: "center", color:"white", padding:0, height: "50%", minWidth:"20em", maxHeight: "20em", width: "100%"}} ><img alt="Xinlin" style={{top:"0px", minWidth:"20em", maxWidth:"100%", }} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/xinlin.jpg?alt=media&token=c625f3e2-e8aa-4407-ace5-dba2feed3c0e"/>
                          <br/> <span  style={{width:"100%", }} >XINLIN LI MORROW</span><br/>
                            <span  style={{textAlign: "center"}}>主任律师</span><br/><br/>
                        </div>
                        <div style={{  padding:10, display: "inline-block", backgroundColor:"FireBrick", height: "50%", width: "100%", color:"white"}} >
                            <span style={{ fontWeight: "bold"}}>XINLIN@MORROWFIRM.COM</span><br/>
                            <span style={{ fontWeight: "bold"}}>213.282.8166</span><br/><br/>
                            <span style={{ fontWeight: "bold"}}>教育背景</span><br/>
                            <span>哥伦比亚大学法学院法律博士，2010</span> <span style={{ fontStyle: "italic"}}>Harlan Fiske Stone学者</span><br/>
                            <span>Middlebury College经济学学士，2007 <span style={{ fontStyle: "italic"}}>cum laude荣誉</span></span><br/><br/>
                            <span style={{ fontWeight: "bold"}}> 执业资格</span><br/>
                            <span>加利福尼亚州</span><br/>
                            <span>纽约州</span><br/>
                        </div>
                    </div>}
                    {lang==="en" && <div style={{width: "50%", maxWidth:"50%", minWidth:"20em", verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Xinlin Li Morrow</span><p/>
                        <span style={{fontSize: "1.1em"}}>Principal</span><p/>

                        <span style={{fontSize: "1em", color:"DimGrey", fontStyle: "italic"}}>Ivy-League-educated and Biglaw-trained trial lawyer</span><p/>
                        ​
                        <span style={{fontSize: ".8em",}}>Xinlin Li Morrow is a strategic business and IP lawyer with nearly a decade of experience litigating and advising clients on complex business disputes involving patents, trade secrets, and contracts. Each year since 2015, Super Lawyers Magazine has recognized Ms. Morrow as a “Rising Star.”</span><p/>
                        <span style={{fontSize: ".8em"}}>
                            Before founding the Morrow Firm, Ms. Morrow practiced law at national litigation powerhouses Irell & Manella and Hueston Hennigan with a focus on business and IP litigation. Her clients have included companies and institutions of all sizes, including T-Mobile, Peloton, Bausch Health, Taco Bell, ClearOne, Core Wireless, TiVo, Juno Therapeutics, BlackBerry, Columbia University, and Los Angeles Dodgers.

                            ​</span><p/>
                            <span style={{fontSize: ".8em"}}>
                            In addition to representing clients in civil business disputes, Ms. Morrow has also successfully represented business executives and professionals facing federal and state criminal investigations and actions.
                ​

                            ​</span><p/>

                        <span style={{fontSize: ".8em"}}>
                             Ms. Morrow is also active in the community. She serves on the board of directors of Los Angeles Intellectual Property Law Association (LAIPLA) and Asian Pacific American Dispute Resolution Center (APADRC).
                        </span><p/>

                            <span style={{fontSize: ".8em"}}>
                            Before entering private practice, Ms. Morrow served as an attorney fellow for the Los Angeles County District Attorney’s Office, where she helped deputy district attorneys in the Hardcore Gang Division prosecute gang-related murders. Later, Ms. Morrow also served as a special prosecutor at the Anaheim City Attorney’s Office and successfully obtained guilty verdicts in two misdemeanor trials as sole lead counsel.

                            ​</span><p/>

                        <span style={{fontSize: ".8em"}}>
                            Ms. Morrow earned her law degree from Columbia Law School where she was a Harlan Fiske Stone Scholar and served as Submissions Editor and Articles Editor for the Columbia Journal of Asian Law. She received a BA in economics from Middlebury College.

                         ​</span><p/>



                    </div>}


                    {lang==="zh" && <div style={{width: "50%", maxWidth:"50%", minWidth:"20em", verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>李馨霖</span><p/>
                        <span style={{fontSize: "1.1em"}}>主任律师</span><p/>

                        <span style={{fontSize: "1em", color:"DimGrey", fontStyle: "italic"}}>拥有常青藤法律博士学位和美国顶尖律所经验的出庭律师.</span><p/>
                        ​
                        <span style={{fontSize: ".8em",}}>李馨霖律师是一位具有战略性眼光的商业和知识产权法律师，拥有近十年的执业经验，为客户处理涉及专利，商业秘密和合同违约等复杂的商业纠纷。自2015年以来，李律师每年都被美国超级律师（Super Lawyers）杂志评为南加州法律界的“上升之星”。</span><p/>
                        <span style={{fontSize: ".8em"}}>
                           在成立美国沫若律师事务所之前，李律师在美国顶级诉讼律师事务所Irell＆Manella和Hueston Hennigan执业，专注于商业和知识产权诉讼。她的客户包括各种规模的公司和机构，包括T-Mobile电信公司、Peloton、博士伦健康公司（Bausch Health）、塔可钟（Taco Bell）、ClearOne、Core Wireless、TiVo、朱诺医疗（Juno Therapeutics）、黑莓（BlackBerry）、哥伦比亚大学（Columbia University）和洛杉矶道奇职业棒球队（Los Angeles Dodgers）。

                            ​</span><p/>
                        <span style={{fontSize: ".8em"}}>
                            除了代表客户处理民事纠纷外，李律师还成功代理了面临联邦和州刑事调查和诉讼的企业高管和专业人士。

                            ​</span><p/>
                        <span style={{fontSize: ".8em"}}>
                           李律师也活跃的参与社区事务。她是洛杉矶知识产权律师协会（LAIPLA）和亚裔美国人争议解决中心（APADRC）的董事会成员。
                            ​</span><p/>
                        <span style={{fontSize: ".8em"}}>
                            在律所执业之前，李律师曾在洛杉矶县地方检察官办公室任职并帮助检察官办公室黑帮犯罪组起诉与黑帮有关的谋杀案。之后，李律师还担任安纳海姆市检察官办公室的特别检察官，并成功在两项轻罪庭审中作为首席律师出庭获得了有罪判决。
                            ​</span><p/>




                    </div>}





                    <div style={{width: "10%", maxWidth:"25%",  verticalAlign:"top",  display: "inline-block", padding: "30px",}} >
                  <img alt="Superlawyer"   style={{top:"0px", minWidth:"8em", maxWidth:"50%", }}src="https://firebasestorage.googleapis.com/v0/b/morrowfirm.appspot.com/o/superlawyer.png?alt=media&token=e03b8d0c-f870-4a59-8c80-30c1da0a7e7e"/>
                    </div>

                </div>
            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang};
}

export default connect(mapStateToProps, {getUser })(about);



// WEBPACK FOOTER //
// ./src/Containers/team.js